import { render, staticRenderFns } from "./RecipeInfoBase.vue?vue&type=template&id=ad72bae0&scoped=true"
import script from "./RecipeInfoBase.vue?vue&type=script&lang=js"
export * from "./RecipeInfoBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad72bae0",
  null
  
)

export default component.exports